import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { registerField } from 'core/forms';

import { TextArea } from 'uikit/inputs';

import styles from '../styles/formFieldTextArea.module.scss';

const defaultSchema = {
  className: '',
  isDisabled: false,
  maxLength: null,
  placeholder: '',
};

const FormFieldTextArea = ({ fieldId, updateField, value = '', schema: propsSchema = {} }) => {
  const schema = { ...defaultSchema, ...propsSchema };
  const { className, isDisabled, maxLength, placeholder } = schema;

  return (
    <TextArea
      className={classNames(styles.element, className)}
      id={fieldId}
      isDisabled={isDisabled}
      maxLength={maxLength}
      onChange={updateField}
      placeholder={placeholder}
      value={value === null ? '' : value}
    />
  );
};

FormFieldTextArea.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.string,
  updateField: PropTypes.func.isRequired,
  schema: PropTypes.shape({
    className: PropTypes.string,
    placeholder: PropTypes.string,
    isDisabled: PropTypes.bool,
    maxLength: PropTypes.number,
  }),
};

registerField('TextArea', memo(FormFieldTextArea));

export default FormFieldTextArea;
